import React from "react"
import { Link } from "gatsby"
import { localizedPath } from "../helpers"
import { useLocalization } from "../hooks/use-localization"


/**
 * Localized Link Properties.
 */
export interface LocalizedLinkProps {
  /** リング先、言語のprefixを抜いてください */
  to : string
  /** リンク先の言語 */
  language ?: string
}

export const LocalizedLink:React.FC<LocalizedLinkProps> = ({ to, language,  ...props }) => {
  const { currentLocaleObj } = useLocalization();

  return <Link {...props} to={localizedPath(language ? language : currentLocaleObj.prefix , to)} />
}
